/**
 * We need to combine the reducers from other files into a root reducer here
 *
 * We also need to re-export all the actions exported by the other slice reducers
 */
import { configureStore } from '@reduxjs/toolkit';
import modalHandlerReducer from './modalHandlerReducer';
import dealersListReducer from './dealersListReducer';
import dealerContextReducer from './dealerContextReducer';
import appConfigReducer from './appConfigReducer';
import { IS_TESTING_ENVIRONMENT } from '../constants/environment';

export const store = configureStore({
  reducer: {
    config: appConfigReducer,
    dealerContext: dealerContextReducer,
    dealersList: dealersListReducer,
    modalState: modalHandlerReducer,
  },
  devTools: IS_TESTING_ENVIRONMENT,
});

const rootReducer = {
  modalState: modalHandlerReducer,
  dealersList: dealersListReducer,
  dealerContext: dealerContextReducer,
};

export type RootState = ReturnType<typeof store.getState>;
export default rootReducer;
